import React from 'react';
import useSWR from 'swr';
import fetcher from '../../utils/fetcher';
import { NavLink, useParams } from 'react-router-dom';
import ReactMarkdown from 'react-markdown';
import { Helmet } from 'react-helmet';
import './style.css'

const InvestorDetail = () => {
  const { dt } = useParams();
  const { data: investorData } = useSWR(`https://api.testworks.co.kr/investors/${dt}`, fetcher);

  if (!investorData) return null;

  return (
    <>
      <Helmet>
        <title>{investorData.title}</title>
        <meta name='description' content='에이아이웍스가 어떻게 기술 기반의 성장을 넘어 더 나은 사회를 위한 변화된 가치를 창출해 내는지 알아보세요.' />
      </Helmet>
      <section className='investorDetail'>
        <section className='visual_wrap_short'>
          <span className='line'></span>
          <div className='inner'>
            <div className='header'>
              <h2>Investor Relations</h2>
            </div>
          </div>
        </section>
        <div className='inner'>
          {/* <div className='header'>
            <h2>Investor Relations</h2>
          </div> */}
          <div className='detailContents'>
            <div className='date'>{investorData.notiday}</div>
            <div className='content'>
              <ReactMarkdown>{investorData.contents}</ReactMarkdown>
            </div>
            <NavLink to='/investorroom' className='listBtn'>목록보기</NavLink>
          </div>
        </div>
      </section>


    </>
  )
}

export default InvestorDetail;